// https://stackoverflow.com/questions/38701803/how-to-get-element-in-user-agent-shadow-root-with-javascript#answer-71692555

export function querySelectorAllShadows(selector, el : HTMLElement | ShadowRoot = document.body) : any[] {
    // recurse on childShadows
    const childShadows = Array.from(el.querySelectorAll('*')).
      map(el => el.shadowRoot).filter(Boolean);
    
    const childResults = childShadows.map(child => querySelectorAllShadows(selector, child));
    
    // fuse all results into singular, flat array
    const result = Array.from(el.querySelectorAll(selector));
    return result.concat(childResults).flat();
  }